import React, { Component } from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import ReactDOM from 'react-dom';
import RecordRTC from 'recordrtc';
import beep from './beep.mp3';
import './Form.css';
import './style.css';
const StereoAudioRecorder = RecordRTC.StereoAudioRecorder;
let peak = 0;

class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message: '',
            conversationContexts: [],
            btnStartRecordingDisabled: false,
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onClick = this.onClick.bind(this);
        this.listening = false;
        this.recorder = null;
        this.microphone = null;
        this.options = null;
        this.isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
        this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        this.isIos = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
        // this.isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test((navigator.userAgent || navigator.vendor || window.opera)) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test((navigator.userAgent || navigator.vendor || window.opera).substr(0, 4));
        this.audio = null;
        this.beep = new Audio(beep);
        this.sendLabel = {
            "it": "INVIA",
            "en": "SEND",
            "ja": "送る",
            "zh-cn": "发送",
            "ru": "ПОСЛАТЬ",
            "fr": "ENVOYER",
            "es": "ENVIAR",
            "de": "SENDEN",
        };
    }
    componentWillReceiveProps(props) {
        if (props.canRecordVoice === false) {
            if (this.listening) {
                console.debug("stopRecording")
                this.stopRecording(false);
            }

            this.props.onListeningVoiceEnd();
        }
    }
    componentDidMount() {
        this.audio = this.refs.audio;
        window.addEventListener("message", (evt) => {
            if (typeof evt.data == 'string') {
                switch (evt.data) {
                    case 'onclose':
                        console.debug("stopRecording"); this.stopRecording(false);
                        break;
                    case 'onStartRecording':
                        console.debug("stopRecording");
                        this.stopRecording(false, () => {
                            this.setState({ btnStartRecordingDisabled: false })
                            this.onClick(true)
                        });
                        break;
                    default: break;
                }
            }
        }, false);
    }

    handleChange(event) {
        this.setState({ message: event.target.value });
    }
    onKeyUp(event) {
        if ((event.which === 13) && (this.state.message.trim() !== '')) {
            this.handleSubmit();
            event.stopPropagation();
            event.preventDefault();
        }
    }
    handleSubmit(e) {
        e && e.preventDefault();
        let message = this.state.message
        if (!message || message.trim() === "") {
            return false;
        }
        this.setState({ message: '' });

        this.props.handleSubmitText(message, undefined, undefined, undefined, undefined, "text_form");
    }

    getTime() {
        return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    setListening(listening) {
        if (listening === true) {
            setTimeout(() => {
                this.listening = listening;
                this.props.onListeningVoiceStart();
                this.beep.play();
            }, 1000);
        } else {
            this.listening = listening;
            this.beep.pause();
            this.beep.currentTime = 0;
            this.props.onListeningVoiceEnd();
        }
    }

    captureMicrophone = (callback) => {
        if (this.microphone) {
            callback(this.microphone);
            return;
        }

        if (typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices.getUserMedia) {
            alert('This browser does not supports WebRTC getUserMedia API.');

            if (!!navigator.getUserMedia) {
                alert('This browser seems supporting deprecated getUserMedia API.');
            }
        }

        navigator.mediaDevices.getUserMedia({
            audio: this.isEdge ? true : {
                echoCancellation: false
            }
        }).then((mic) => {
            callback(mic);
        }).catch((error) => {
            alert('Unable to capture your microphone. Please check console logs.');
            console.error(error);
        });
    }

    setSrcObject(stream, element) {
        if ('srcObject' in element) {
            element.srcObject = stream;
        } else if ('mozSrcObject' in element) {
            element.mozSrcObject = stream;
        } else {
            element.srcObject = stream;
        }
    }

    onClick(_listening) {
        let silenceInstants = 0;
        if (this.props.canRecordVoice === false && _listening !== true) {
            return;
        }

        if (this.listening) {
            this.recorder && this.recorder.stopRecording();
            this.toggleListeningMessage(false);
            this.setListening(false)
            clearTimeout(this.to);
            return;
        }

        if (!this.microphone) {
            this.captureMicrophone((mic) => {
                this.microphone = mic;

                if (this.isSafari) {
                    this.audio.muted = true;
                    this.setSrcObject(this.microphone, this.audio);
                    this.setState({ btnStartRecordingDisabled: false });
                    return;
                }

                this.click(this.refs.btnStartRecording);
                this.setListening(true)
            });
            return;
        } else {
            this.setListening(true);
        }
        this.audio.muted = true;
        this.setSrcObject(this.microphone, this.audio);
        this.to = setTimeout(() => {
            this.stopRecording(true);
        }, 7000)

        this.options = {
            type: 'audio',
            numberOfAudioChannels: 1,
            checkForInactiveTracks: true,
            mimeType: "audio/ogg",
            recorderType: StereoAudioRecorder,
            desiredSampRate: 16000,
            disableLogs: true,
            timeSlice: 50,
            ondataavailable: (blob, stereoAudioRecorder) => {
                let current = Number(stereoAudioRecorder.instant);

                if (current > peak) {
                    peak = current;
                }

                // check for silence
                if (current > 0.4 * peak) {
                    silenceInstants = 0;
                    this.props.onRecording();
                } else {
                    silenceInstants++;
                }

                if (silenceInstants > 40) {
                    silenceInstants = 0;
                    console.debug("stopRecording");
                    clearTimeout(this.to);
                    this.stopRecording(true);
                }
            }
        };

        if (navigator.platform && navigator.platform.toString().toLowerCase().indexOf('win') === -1) {
            this.options.sampleRate = 48000;
        }

        if (this.isSafari) {
            this.options.sampleRate = 44100;
            this.options.bufferSize = 4096;
        }

        if (this.recorder) {
            this.recorder.destroy();
            this.recorder = null;
        }

        this.recorder = RecordRTC(this.microphone, this.options);

        this.recorder.startRecording();

        this.toggleListeningMessage();
    };

    toggleListeningMessage = (flag) => {
    }

    stopRecording(sendAudio, callback) {
        if (!this.recorder) {
            callback && callback();
        }
        clearTimeout(this.to);
        this.recorder && this.recorder.stopRecording(() => {
            this.setListening(false)
            this.toggleListeningMessage(false);
            this.props.onRecording();

            this.setState({ btnStartRecordingDisabled: false });

            setTimeout(() => {
                if (!this.audio.paused) {
                    return;
                }

                setTimeout(() => {
                    if (!this.audio.paused) {
                        return;
                    }
                }, 1000);
            }, 300);

            setTimeout(() => {
                if (sendAudio) {
                    this.sendRecording();
                }
            }, 500);

            if (this.isSafari) {
                this.setState({ btnStartRecordingDisabled: false });

                if (this.microphone) {
                    this.microphone.stop();
                    this.microphone = null;
                }
            }

            callback && callback();
        });
    };

    toggleLoadingMessage = () => {
        this.props.onLoadingStateChanged(!this.state.loading)
        this.setState({ loading: !this.state.loading });
    }

    click = (ref) => {
        const el = ReactDOM.findDOMNode(ref);
        el.disabled = false;
        let evt = document.createEvent('Event');
        evt.initEvent('click', true, true);
        el.dispatchEvent(evt);
    }

    sendRecording() {
        this.props.onRecording();

        this.recorder.getDataURL(async (dataURL) => {
            this.toggleLoadingMessage();
            var self = this;

            this.props
                .handleSubmitAudio(dataURL.substr(dataURL.indexOf(',') + 1), this.options)
                .then(data => {
                    self.props.onRecording();
                    self.setState({ btnStartRecordingDisabled: false });
                    this.toggleLoadingMessage();

                    // get the permissions on safari
                    if (this.isSafari) {
                        self.click(self.refs.btnStartRecording);
                    }

                    if (typeof data.response !== 'undefined') {
                        if (typeof data.response.queryText !== 'undefined') {
                            self.props.onNewMessage({
                                sender: 'user',
                                message: data.response.queryText,
                                time: this.getTime()
                            });
                        }

                        if (typeof data.response.fulfillmentText !== 'undefined') {
                            self.props.onNewMessage({
                                sender: 'bot',
                                message: data.response.fulfillmentText,
                                time: this.getTime()
                            });
                        } else {
                            self.props.onNewMessage({
                                sender: 'user',
                                message: data.response.queryText,
                                time: this.getTime()
                            });
                        }

                        if (typeof data.response.outputAudio) {
                            let sound = new Audio("data:audio/mp3;base64," + data.response.outputAudio);

                            if (this.isSafari) {
                                self.appendPlayAudio(sound);
                                self.setState({ btnStartRecordingDisabled: false });
                            } else {
                                self.setState({ btnStartRecordingDisabled: true });
                            }
                            sound.play().then(() => {
                                self.setState({ btnStartRecordingDisabled: false })
                                self.props.onRecording();
                            }).catch(() => {
                            });
                        }
                    }
                })
                .catch((data) => {
                    self.toggleLoadingMessage();
                    self.setState({ btnStartRecordingDisabled: false });
                });
        });
    }

    appendPlayAudio = audio => {
        if (typeof audio !== 'undefined') {
            this.props.onNewMessage({
                audio: true,
                src: audio.src
            })
        }
    }

    render() {
        return (
            <form method="POST" action="query" ref="query_form" onSubmit={this.handleSubmit} style={{ display: "flex" }}>
                <div style={{ "top": "-1000px", "left": 0, "height": 0, "position": "absolute", "width": 0 }}>
                    <audio controls="" autoPlay="" ref="audio" />
                </div>
                <div className="input-form">
                    {this.props.text !== true ? null :
                        <TextareaAutosize value={this.state.message}
                            onChange={this.handleChange}
                            onKeyDown={this.onKeyUp}
                            style={{
                                fontSize: 'calc(11px + 1.5vmin)',
                                borderRadius: "0",
                                letterSpacing: '0.15vw'
                            }}
                            form="query_form"
                            rows={2}
                            className="form-control type_msg"
                            // placeholder="Hey, ask me something..."
                            placeholder={this.props.textInputPlaceholder}
                            id="input_text"
                            name="input_text"
                            ref="text"
                        />
                    }
                    <input type="submit" style={{ top: "-1000px", left: 0, height: 0, position: "absolute", width: 0 }} />
                    <input placeholder="Language" type="text" id="input_language" name="input_language" style={{ display: "none" }} />
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                        {this.props.microphone === true ?
                            <button
                                {...this.state.btnStartRecordingDisabled ? { "disabled": "disabled" } : null}
                                type="button"
                                className="record_btn microphone"
                                ref="btnStartRecording"
                                id="btn-start-recording"
                                onClick={() => this.onClick()}>
                            </button>
                            : this.props.text === true ?
                                <button type="button" className="record_btn" id="submit-btn" onClick={() => this.handleSubmit(null)}>
                                    <span>{this.sendLabel[this.props.locale]}</span>
                                </button>
                                : null
                        }
                    </div>
                    <span style={{ clear: "both" }}></span>
                </div>

            </form>
        );
    }
}

export default Form;
